import React from 'react'

export default function GamingVideo() {
    return (
        <div>
            
        </div>
    )
}
